import { render } from "./FleetEditor.vue?vue&type=template&id=6ac876d8"
import script from "./FleetEditor.vue?vue&type=script&lang=js"
export * from "./FleetEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__